import $ from 'jquery';
import config from '../config';
const store = {};
export default function () {
    $(document).ready(() => {
        // Cached elements
        var $social = $('.social');
        var $more = $social.find('.more');
        var $popUp = $social.find('.share-popup');
        var $body = $('body');

        function toggleMenu(e) {
            e.stopPropagation();
            e.preventDefault();
            let ind = $more.index($(this));

            $($popUp[ind]).toggleClass('_active');
        }

        function closeTips() {
            $popUp.removeClass('_active');
        }

        if (config.get('initialPageLoad') === false) {
            $more.off('click', store.toggleMenu);
            $body.off('click', store.closeTips);
        }

        // store original functions to be removed
        store.toggleMenu = toggleMenu;
        store.closeTips = closeTips;

        /**
         * Initializes Po;;
         * @return {void}
         */

        $more.on('click', store.toggleMenu);
        $body.on('click', store.closeTips);

    });
}
